<template lang="pug">
   v-btn-toggle.d-flex( 
      v-model='items'
      dense
      multiple
      borderless
      color='green'
    )
      v-btn(
        block
        depressed
        :value='indexValue'
        @click='$emit("click")'
      )
        v-icon mdi-check
        h5 {{ text }} 
        h5.ml-1(v-if="appendAmount") {{ appendAmount | currency }}
</template>
<script>
export default {
  props:{
    indexValue: {
      type:[Number,String],
      default: null
    },
    value:{
      type:Array,
      default: () =>[]
    },
    text:{
      type:String,
      default:null
    },
    appendAmount: { 
      type:[String,Number],
      default:null
    }
  },
  data: ()=> ({
    items :[]
  }),
  watch: {
    value (val) {
      this.items=val
    },
    items (val) {
      this.$emit('imput',val)
    }
  }
}
</script>